import {GetParkNote} from '@/graphql/queries/ParkNote.graphql'
import {EditParkNote} from '@/graphql/mutations/ParkNote.graphql'

export default {
  data(){
    return {

    };
  },

  computed : {
    parkNoteId(){
      return this.$route.params?.noteId;
    }
  },

  apollo : {
    parkNote  : {
      query: GetParkNote,

      variables(){
        return {
          id  : this.parkNoteId
        };
      },

      fetchPolicy: 'no-cache',

      skip(){
        if(this.isModalOpend === true){
          if(this.editorBehaviour === 'edit'){
            return false;
          }else{
            return true;
          }
        }else{
          return true;
        }
      },

      error(err){
        const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(err);
        
        this.apolloResultValidation(simpleErrorSet);
      }
    }
  },

  watch : {
    parkNote : {
      handler(data){
        if(typeof data === 'undefined') return;
        if(data === null) return;
        
        if(data.title !== null && data.title !== ''){
          this.defaultTitle = data.title;
        }

        if(data.body !== null && data.body !== ''){
          this.defaultBodyDeltaString = data.body;
        }

        if(data.text_counter !== null && data.text_counter !== ''){
          this.textCountingStartLimit = data.text_counter;
        }
      },
      deep: true
    },
  },

  methods : {
    executeEditParkNote(payload){
      return new Promise((resolve) => {
        this.$apollo.mutate({
          mutation  : EditParkNote,
          variables : {
            parkNoteId  : payload.parkNoteId,
            title       : payload.title,
            body        : payload.body,
            text        : payload.text,
            textCounter : payload.textCounter
          },
          update    : (store, {data: {EditParkNote}}) => {
            if(EditParkNote !== null){
              store.writeQuery({
                query     : GetParkNote,
                variables : {
                  id  : EditParkNote.id
                },
                data      : {
                  parkNote : EditParkNote
                }
              });
            }
          }
        }).then(async ({data: {EditParkNote}}) => {
          resolve(EditParkNote);
        }).catch(async (error) => {
          const simpleErrorSet = this.getApolloSimpleErrorFromApolloError(error);

          if(typeof simpleErrorSet.firstError.field !== 'undefined'){
            const errorMessageTextSet = {
              'default'                               : "エラーが発生しました。",
              'Could not enough character ink body'   : "&nbsp;インクが足りません。",
              'This text include In-Acceptable wrod.' : "&nbsp;こちらの内容はご投稿いただくことができかねます。",
            };

            let errorMessageText = '';

            if(typeof errorMessageTextSet[simpleErrorSet.firstError.message] !== 'undefined'){
              errorMessageText = errorMessageTextSet[simpleErrorSet.firstError.message];
            }else{
              errorMessageText = errorMessageTextSet['default'];
            }

            this.$store.dispatch({
              type        : 'flashMessage/updateFlashMessage',
              hasMessage  : true,
              message     : errorMessageText,
              status      : 'error',
              hasControl  : true,
              autoClose   : 3000
            }, {root:true});
          }

          resolve(false);
        });
      });
    }
  }
}